<template>
  <div class="app">
    <div id="global-messages" v-if="errors">
      <BaseAlert
        v-if="errors"
        :content="errors"
        type="error"
        @dismiss-alert="clearGlobalErrors"
      />
    </div>

    <transition name="slide-fade">
      <div id="global-messages">
        <BaseAlert
          v-if="notification && !notification.alertComponent"
          :type="notification.type"
          :content="notification.content"
        />
      </div>
    </transition>

    <div id="global-messages" v-if="notification && notification.alertComponent">
      <BaseAlert
        v-if="notification && notification.alertComponent"
        :content="notification.content"
        type="warning"
        fontSize="16"
        @dismiss-alert="clearGlobalNotification"
      />
    </div>

    <!-- <ChatWabee ref="chatWabee" /> -->
    <router-view/>
  </div>
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import AuthStore from '@/modules/auth/store'
import CampaignsStore from '@/modules/campaigns/store'
import UsersStore from '@/modules/users/store'
import UsersService from '@/modules/users/services/users-service'
import { mapState, mapActions } from 'vuex'
import { registerVuexModule } from '@/utils'
import seo from '@/mixins/seo'

import BaseAlert from '@/components/common/Alert/BaseAlert'
// import ChatWabee from '@/components/chat/ChatWabee'

export default {
  name: 'App',
  mixins: [seo],
  components: {
    BaseAlert
    // ChatWabee
  },
  data () {
    return {
      showAlert: true
    }
  },
  metaInfo () {
    return {
      title: this.seoDefaultTitle,
      titleTemplate: `%s | ${this.seoDefaultTitleAppend}`,
      meta: [
      ]
    }
  },
  created () {
    registerVuexModule(this.$store, 'auth', AuthStore)
    registerVuexModule(this.$store, 'users', UsersStore)
    registerVuexModule(this.$store, 'campaigns', CampaignsStore)

    // Get the logged user when the page first loads
    this.getLoggedUser()
    // Check for referral code
    this.checkForReferralCode()
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated,
      isImpersonating: state => state.isImpersonating
    }),
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      errors: state => state.errors,
      isSidebarOpen: state => state.isSidebarOpen,
      notification: state => state.notification
    })
  },
  methods: {
    ...mapActions(['clearErrors', 'clearNotification']),
    clearGlobalErrors () {
      this.clearErrors()
    },
    clearGlobalNotification () {
      this.clearNotification()
    },
    clearMessage (selector) {
      document.querySelector(selector).remove()
    },
    /**
     * Check URL for referral code
     */
    checkForReferralCode () {
      if (!this.authenticated) {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const code = urlParams.get('referral')
        if (code) {
          window.localStorage.setItem('referral', code)
        }
      }
    },
    /**
     * Get logged user
     */
    async getLoggedUser () {
      const language = await UsersService.getCookie('user_language')
      if (language) this.$i18n.locale = language
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      const token = urlParams.get('impersonate')
      if (token) {
        const originalToken = urlParams.get('original_token')
        await AuthService.impersonate(token, originalToken)

        window.location.href = urlParams.get('page') ?? '/'
      } else {
        // Check if the user is authenticated and if the user in the store is filled
        if (this.authenticated) {
          if (!this.user) {
            try {
              await UsersService.me()
              this.$i18n.locale = this.user.language
            } catch (error) {
              error.handleGlobally && error.handleGlobally()
            }
          }
        }
      }
    },
    dismissAlert () {
      this.showAlert = false
    },
    async stopImpersonate () {
      await AuthService.stopImpersonate()
      window.location.href = '/'
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  display: contents;
}

#global-messages {
  position: fixed;
  top: 120px;
  left: calc(50% - 140px);
  width: 280px;
  z-index: 10;

  @include tablet {
    width: 500px;
    left: calc(50% - 250px);
  }
}

.alert-pixel-roads-style {
  position: absolute;
  z-index: 1;
  top: 50px;
  width: 90%;
  left: calc(50% - 45%);

  @include desktop-lg {
    width: 80%;
    left: calc(50% - 40%);
  }

  @media (min-width: 1470px) {
    width: 70%;
    left: calc(50% - 35%);
  }
}

</style>
